// Reduce zone.js patching overhead for high-frequency events
// Must be imported before zone.js in polyfills.ts
// See: https://angular.dev/guide/zone#disabling-specific-event-patching
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).__zone_symbol__UNPATCHED_EVENTS = [
  'scroll',
  'mousemove',
  'touchmove',
  'pointermove',
  'wheel',
];

